export const linkHandler = () => {
  document.querySelectorAll('[href^="#"]:not([href="#"])').forEach(function(el){
    const hash = el.hash
    if( hash == '#contact' ) return
    el.addEventListener('click', function(e){
      e.preventDefault()
      if(hash == '#top'){
        window.scroll({top: 0, behavior: 'smooth'})
        return
      } 
      const el = document.querySelector(hash)
      if(el){
        const header = document.querySelector('header').clientHeight 
        window.scroll({
          top: el.getBoundingClientRect().top + window.pageYOffset - header,
          behavior: 'smooth'
        })
      }
    })
  })
}